import React, { useEffect, useState } from "react";
import BackIcon from "assets/images/general/back.svg";
import LoaderComponent from "components/LoaderComponent";
import { useLocation, useNavigate } from "react-router-dom";
import AccordionComponent from "components/AccordionComponent";
import { CallAPI } from "actions/General";

function ProgramCoursesList() {
  const navigate = useNavigate();
  const location = useLocation();
  const [values, setValues] = useState({});
  const [loader, setLoader] = useState(false);
  const [selectedAccordion, setSelectedAccordion] = useState(-1);
  const getCourseModuleUnits = async (id) => {
    const result = await CallAPI(
      "GET_PROGRAM_COURSES",
      {},
      id,
      setLoader,
      null,
      null
    );
    if (result.status) {
      const details = result.data;
      setValues({
        title: details.title,
        compulsory_courses: details.compulsory_courses.map(
          (singleCompulsoryCourse) => {
            return singleCompulsoryCourse.title;
          }
        ),
        elective_courses: details.elective_courses.map(
          (singleElectiveCourse) => {
            return singleElectiveCourse.title;
          }
        ),
        pre_requisite_courses: details.pre_req_courses
          ? details.pre_req_courses.map((singleElectiveCourse) => {
              return singleElectiveCourse.title;
            })
          : [],
      });
    }
  };
  useEffect(() => {
    if (
      location &&
      location.state &&
      location.state.record_id &&
      location.state.record_id !== ""
    )
      getCourseModuleUnits(location.state.record_id);
  }, [location]);
  const backToCourses = () => {
    navigate("/program");
  };
  return (
    <div className="card py-7 course-admin-detail">
      {loader ? (
        <LoaderComponent classes="" />
      ) : (
        <>
          <div className="header-detail">
            <img onClick={backToCourses} src={BackIcon} alt="back" />
            <span className="title">{values.title}</span>
          </div>
          <div className="detail">
            <span className="title">Mandatory Courses</span>
            <div className="units-list">
              {
                <span className="no-accordion">
                  {values.compulsory_courses &&
                  values.compulsory_courses.length > 0
                    ? values.compulsory_courses.join(", ")
                    : "No Mandatory Courses"}
                </span>
              }
            </div>
          </div>
          <div className="detail">
            <span className="title">Elective Courses</span>
            <div className="units-list">
              {
                <span className="no-accordion">
                  {values.elective_courses && values.elective_courses.length > 0
                    ? values.elective_courses.join(", ")
                    : "No Mandatory Courses"}
                </span>
              }
            </div>
          </div>
          <div className="detail">
            <span className="title">Pre Requisite Courses</span>
            <div className="units-list">
              {
                <span className="no-accordion">
                  {values.pre_requisite_courses &&
                  values.pre_requisite_courses.length > 0
                    ? values.pre_requisite_courses.join(", ")
                    : "No Mandatory Courses"}
                </span>
              }
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ProgramCoursesList;
